import { css } from 'styled-components';
import { FeatureProps } from '../../../../components/Feature/Feature';
import {
  FeatureGrid,
  ImageGridItem,
  StyledImage,
  TextGridItem,
} from '../../../../components/Feature/FeatureContainer/styles';
import {
  Heading,
  Subheading,
} from '../../../../components/Feature/FeatureContents/styles';
import { gridItemPropsOverride } from '../../../../components/Grid/GridItem/styles';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';

const mobileImageSize = css`
  height: 224px;
`;

const mobileImageStyle = css`
  ${mobileImageSize}
  img {
    ${mobileImageSize}
  }
`;

const tabletImageSize = css`
  height: 560px;
`;

const tabletImageStyle = css`
  ${tabletImageSize}

  img {
    ${tabletImageSize}
  }
`;

const desktopImageSize = css`
  width: 544px;
  height: 560px;
`;

const desktopImageStyle = css`
  ${desktopImageSize}

  img {
    ${desktopImageSize}
  }
`;

export default css<FeatureProps>`
  ${TextGridItem} {
    ${({ image }) =>
      gridItemPropsOverride({
        desktop: image ? 6 : 8,
        tabletLandscape: 12,
        tabletPortrait: 8,
        mobile: 4,
      })}
  }

  ${ImageGridItem} {
    ${gridItemPropsOverride({
      desktop: 6,
      tabletLandscape: 12,
      tabletPortrait: 8,
      mobile: 4,
    })}
  }

  ${Heading} {
    margin-top: ${spacing(3)};

    ${mediaQuery.desktop`
        margin-top: 0;
      `}
  }

  ${Subheading} {
    margin-top: ${spacing(2)};
    margin-bottom: ${spacing(3)};
  }

  ${StyledImage} {
    object-fit: cover;
    img {
      object-fit: cover;
    }

    ${mobileImageStyle}
    ${mediaQuery.tabletPortrait`
      ${tabletImageStyle}
    `}
    ${mediaQuery.desktop`
      ${desktopImageStyle}
    `}
  }

  &&${FeatureGrid} {
    margin-top: ${spacing(6)};
    margin-bottom: ${spacing(6)};

    ${(props) => css`
      ${mediaQuery.tabletLandscape`
        flex-direction: ${props.invertContentOnMobile ? 'column-reverse' : 'column'};
      `}

      ${mediaQuery.desktop`
        flex-direction: ${props.invertContent ? 'row-reverse' : 'row'};
      `}
    `};
  }
`;
